import styled, { css } from 'styled-components';
import bar from './media/bar.png';

export const BannerWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.white.primary};
    display: flex;
    flex-direction: column;
  `}
`;

export const BannerContainer = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding: 24px 40px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      align-items: flex-start;
      flex-direction: column;
      gap: 8px;
      justify-content: flex-start;
      padding: 16px;
    }
  `}
`;

export const Title = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px 0px 0px 16px;
    max-width: 250px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      margin: 0px;
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    fon-weight: ${theme.v2.font.weights.regular};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px 0px 0px 24px;
    max-width: 450px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      margin: 0px;
    }
  `}
`;

export const ButtonWrapper = styled.div`
  margin: 0px 0px 0px auto;
`;

export const BottomImage = styled.div`
  background-image: url(${bar});
  display: block;
  height:4px;
  min-width: 100%;
`;

export const ModalContent = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.brand.primaryUltraLight};
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 360px;
    padding: 24px 8px;
    position: relative;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      height: 100%;
      justify-content: flex-start;
      padding: 24px 32px;
    }
  `}
`;

export const ModalTitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 36px auto 0px;
    text-align: center;
    width: fit-content;
  `}
`;


export const ModalDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 16px auto 0px;
    max-width: 462px;
    text-align: center;
  `}
`;


export const NavButton = styled.button`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 100%;
    border: 0px;
    cursor: pointer;
    display: flex;
    height: 32px;
    justify-content: center;
    position: absolute;
    top: calc(50% - 16px);
    width: 32px;
  `}
`;


export const BackButton = styled(NavButton)`
  left: 4px;
`;

export const NextButton = styled(NavButton)`
  right: 4px;
`;

export const ButtonRow = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 32px 0px 0px;
`;

export const IconWrapper = styled.div`
  ${({ transparent }) => css`
    display: block;
    position: relative;
    
    label {
      left: calc(50% - 22px);
      position: absolute;
      top: calc(50% - 12px);
      z-index: 999;
    }

    ${transparent && css`
      svg {
        fill: transparent;
        stroke: transparent;
        * {
          fill: transparent;
          stroke: transparent;
        }
      }
    `}
  `}
`;
